"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var restful_model_1 = __importDefault(require("./restful-model"));
var attributes_1 = __importDefault(require("./attributes"));
var Component = /** @class */ (function (_super) {
    __extends(Component, _super);
    function Component(connection, props) {
        var _this = _super.call(this, connection, props) || this;
        _this.initAttributes(props);
        return _this;
    }
    Component.prototype.saveEndpoint = function () {
        return "/component/" + this.connection.clientId;
    };
    Component.prototype.save = function (params, callback) {
        if (params === void 0) { params = {}; }
        return _super.prototype.save.call(this, params, callback);
    };
    Component.prototype.saveRequestBody = function () {
        var json = _super.prototype.saveRequestBody.call(this);
        if (this.id) {
            // Cannot cannot send these values after creation
            delete json.access_token;
            delete json.public_application_id;
            delete json.type;
        }
        return json;
    };
    Component.collectionName = 'component';
    Component.attributes = __assign(__assign({}, restful_model_1.default.attributes), { name: attributes_1.default.String({
            modelKey: 'name',
        }), type: attributes_1.default.String({
            modelKey: 'type',
        }), action: attributes_1.default.Number({
            modelKey: 'action',
        }), active: attributes_1.default.Boolean({
            modelKey: 'active',
        }), settings: attributes_1.default.Object({
            modelKey: 'settings',
        }), allowedDomains: attributes_1.default.StringList({
            modelKey: 'allowedDomains',
            jsonKey: 'allowed_domains',
        }), publicAccountId: attributes_1.default.String({
            modelKey: 'publicAccountId',
            jsonKey: 'public_account_id',
        }), publicTokenId: attributes_1.default.String({
            modelKey: 'publicTokenId',
            jsonKey: 'public_token_id',
        }), publicApplicationId: attributes_1.default.String({
            modelKey: 'publicApplicationId',
            jsonKey: 'public_application_id',
        }), accessToken: attributes_1.default.String({
            modelKey: 'accessToken',
            jsonKey: 'access_token',
        }), createdAt: attributes_1.default.Date({
            modelKey: 'createdAt',
            jsonKey: 'created_at',
        }), updatedAt: attributes_1.default.Date({
            modelKey: 'updatedAt',
            jsonKey: 'updated_at',
        }) });
    return Component;
}(restful_model_1.default));
exports.default = Component;
